import {
  CreditCardDisplayStatus,
  CreditCardStatus,
  CreditCardType,
} from 'src/models/creditCard.models'
import { CreditCardPermissions } from 'src/models/creditCardPermissions.models'
import { VirtualCardStatus } from 'src/models/virtualCard.models'
import {
  StatisticAggregateType,
  StatisticModelType,
  StatisticRequest,
} from 'src/requests/statistics.request'

// TODO: add the remaining keys from globalDebouncedDispatcher appStatisticsKeys
export enum StatisticsKeys {
  CreditCardsSourcePhysicalClearingsLinkedCount = 'CreditCardsSourcePhysicalClearingsLinkedCount',
  VirtualCardsActiveCount = 'VirtualCardsActiveCount',
  VirtualCardsCount = 'VirtualCardsCount',
  BudgetsCount = 'BudgetsCount',
  CreditCardsActiveCanIssueVirtualCardsCount = 'CreditCardsActiveCanIssueVirtualCardsCount',
  CreditCardsActiveStandardCanIssueVirtualCardsCount = 'CreditCardsActiveStandardCanIssueVirtualCardsCount',
  CreditCardsActiveRecurrenceEnabledCanIssueVirtualCardsCount = 'CreditCardsActiveRecurrenceEnabledCanIssueVirtualCardsCount',
  CreditCardsActiveDirectEnabledCanIssueVirtualCardsCount = 'CreditCardsActiveDirectEnabledCanIssueVirtualCardsCount',
  CreditCardsActiveBalanceLockEnabledCanIssueVirtualCardsCount = 'CreditCardsActiveBalanceLockEnabledCanIssueVirtualCardsCount',
  CreditCardsActiveIssuerCycleEnabledCanIssueVirtualCardsCount = 'CreditCardsActiveIssuerCycleEnabledCanIssueVirtualCardsCount',
  CreditCardsActiveSourceCanIssueVirtualCardsCount = 'CreditCardsActiveSourceCanIssueVirtualCardsCount',
  CreditCardsActiveSourceStandardCanIssueVirtualCardsCount = 'CreditCardsActiveSourceStandardCanIssueVirtualCardsCount',
  CreditCardsActiveSourceRecurrenceEnabledCanIssueVirtualCardsCount = 'CreditCardsActiveSourceRecurrenceEnabledCanIssueVirtualCardsCount',
  CreditCardsActiveSourceDirectEnabledCanIssueVirtualCardsCount = 'CreditCardsActiveSourceDirectEnabledCanIssueVirtualCardsCount',
  CreditCardsActiveSourceBalanceLockEnabledCanIssueVirtualCardsCount = 'CreditCardsActiveSourceBalanceLockEnabledCanIssueVirtualCardsCount',
  CreditCardsActiveSourceIssuerCycleEnabledCanIssueVirtualCardsCount = 'CreditCardsActiveSourceIssuerCycleEnabledCanIssueVirtualCardsCount',
  VirtualCardsRecipientMeCount = 'VirtualCardsRecipientMeCount',
  CreditCardsDelegateCount = 'CreditCardsDelegateCount',
  CreditCardsActiveDelegateCount = 'CreditCardsActiveDelegateCount',
  CreditCardsSourceCount = 'CreditCardsSourceCount',
  CreditCardsOrgSourceCount = 'CreditCardsOrgSourceCount',
  CreditCardsActiveSourceCount = 'CreditCardsActiveSourceCount',
}

export const StatisticsRequestsBody: Record<StatisticsKeys, StatisticRequest> =
  {
    [StatisticsKeys.CreditCardsSourcePhysicalClearingsLinkedCount]: {
      agg: StatisticAggregateType.Count,
      type: StatisticModelType.CreditCard,
      query: {
        type: CreditCardType.Source,
        physicalClearingsEnabled: true,
        withPermission: CreditCardPermissions.Read,
      },
    },
    [StatisticsKeys.VirtualCardsActiveCount]: {
      agg: StatisticAggregateType.Count,
      type: StatisticModelType.VirtualCard,
      query: {
        status: VirtualCardStatus.Active,
      },
    },
    [StatisticsKeys.VirtualCardsCount]: {
      agg: StatisticAggregateType.Count,
      type: StatisticModelType.VirtualCard,
      query: {},
    },
    [StatisticsKeys.BudgetsCount]: {
      agg: StatisticAggregateType.Count,
      type: StatisticModelType.CreditCard,
      query: {},
    },
    [StatisticsKeys.CreditCardsActiveCanIssueVirtualCardsCount]: {
      agg: StatisticAggregateType.Count,
      type: StatisticModelType.CreditCard,
      query: {
        status: CreditCardStatus.Active,
        withPermission: CreditCardPermissions.IssueVirtualCards,
      },
    },
    [StatisticsKeys.CreditCardsActiveStandardCanIssueVirtualCardsCount]: {
      agg: StatisticAggregateType.Count,
      type: StatisticModelType.CreditCard,
      query: {
        status: CreditCardStatus.Active,
        withPermission: CreditCardPermissions.IssueVirtualCards,
        balanceLockedEnabled: false,
      },
    },
    [StatisticsKeys.CreditCardsActiveRecurrenceEnabledCanIssueVirtualCardsCount]:
      {
        agg: StatisticAggregateType.Count,
        type: StatisticModelType.CreditCard,
        query: {
          status: CreditCardStatus.Active,
          withPermission: CreditCardPermissions.IssueVirtualCards,
          recurrenceEnabled: true,
        },
      },
    [StatisticsKeys.CreditCardsActiveDirectEnabledCanIssueVirtualCardsCount]: {
      agg: StatisticAggregateType.Count,
      type: StatisticModelType.CreditCard,
      query: {
        status: CreditCardStatus.Active,
        withPermission: CreditCardPermissions.IssueVirtualCards,
        directEnabled: true,
      },
    },
    [StatisticsKeys.CreditCardsActiveBalanceLockEnabledCanIssueVirtualCardsCount]:
      {
        agg: StatisticAggregateType.Count,
        type: StatisticModelType.CreditCard,
        query: {
          status: CreditCardStatus.Active,
          withPermission: CreditCardPermissions.IssueVirtualCards,
          balanceLockedEnabled: true,
        },
      },
    [StatisticsKeys.CreditCardsActiveIssuerCycleEnabledCanIssueVirtualCardsCount]:
      {
        agg: StatisticAggregateType.Count,
        type: StatisticModelType.CreditCard,
        query: {
          status: CreditCardStatus.Active,
          withPermission: CreditCardPermissions.IssueVirtualCards,
          issuerCycleEnabled: true,
        },
      },
    [StatisticsKeys.CreditCardsActiveSourceCanIssueVirtualCardsCount]: {
      agg: StatisticAggregateType.Count,
      type: StatisticModelType.CreditCard,
      query: {
        status: CreditCardStatus.Active,
        type: CreditCardType.Source,
        withPermission: CreditCardPermissions.IssueVirtualCards,
      },
    },
    [StatisticsKeys.CreditCardsActiveSourceStandardCanIssueVirtualCardsCount]: {
      agg: StatisticAggregateType.Count,
      type: StatisticModelType.CreditCard,
      query: {
        status: CreditCardStatus.Active,
        type: CreditCardType.Source,
        withPermission: CreditCardPermissions.IssueVirtualCards,
        balanceLockedEnabled: false,
      },
    },
    [StatisticsKeys.CreditCardsActiveSourceRecurrenceEnabledCanIssueVirtualCardsCount]:
      {
        agg: StatisticAggregateType.Count,
        type: StatisticModelType.CreditCard,
        query: {
          status: CreditCardStatus.Active,
          type: CreditCardType.Source,
          withPermission: CreditCardPermissions.IssueVirtualCards,
          recurrenceEnabled: true,
        },
      },
    [StatisticsKeys.CreditCardsActiveSourceDirectEnabledCanIssueVirtualCardsCount]:
      {
        agg: StatisticAggregateType.Count,
        type: StatisticModelType.CreditCard,
        query: {
          status: CreditCardStatus.Active,
          type: CreditCardType.Source,
          withPermission: CreditCardPermissions.IssueVirtualCards,
          directEnabled: true,
        },
      },
    [StatisticsKeys.CreditCardsActiveSourceBalanceLockEnabledCanIssueVirtualCardsCount]:
      {
        agg: StatisticAggregateType.Count,
        type: StatisticModelType.CreditCard,
        query: {
          status: CreditCardStatus.Active,
          type: CreditCardType.Source,
          withPermission: CreditCardPermissions.IssueVirtualCards,
          balanceLockedEnabled: true,
        },
      },
    [StatisticsKeys.CreditCardsActiveSourceIssuerCycleEnabledCanIssueVirtualCardsCount]:
      {
        agg: StatisticAggregateType.Count,
        type: StatisticModelType.CreditCard,
        query: {
          status: CreditCardStatus.Active,
          type: CreditCardType.Source,
          withPermission: CreditCardPermissions.IssueVirtualCards,
          issuerCycleEnabled: true,
        },
      },
    [StatisticsKeys.VirtualCardsRecipientMeCount]: {
      agg: StatisticAggregateType.Count,
      type: StatisticModelType.VirtualCard,
      query: {
        recipient: 'me',
      },
    },
    [StatisticsKeys.CreditCardsDelegateCount]: {
      agg: StatisticAggregateType.Count,
      type: StatisticModelType.CreditCard,
      query: {
        type: CreditCardType.Delegate,
      },
    },
    [StatisticsKeys.CreditCardsActiveDelegateCount]: {
      agg: StatisticAggregateType.Count,
      type: StatisticModelType.CreditCard,
      query: {
        status: CreditCardStatus.Active,
        type: CreditCardType.Delegate,
      },
    },
    [StatisticsKeys.CreditCardsSourceCount]: {
      agg: StatisticAggregateType.Count,
      type: StatisticModelType.CreditCard,
      query: {
        type: CreditCardType.Source,
      },
    },
    // Org-wide source-card count. The viewer-scoped `CreditCardsSourceCount`
    // above counts only cards the authed user can read, which would miss
    // cards registered by other members of the org (e.g., a previous owner
    // who got demoted). EX-39432 uses this for the onboarding drop-off
    // redirect so a promoted owner inheriting an already-set-up org doesn't
    // get pushed back through card registration.
    [StatisticsKeys.CreditCardsOrgSourceCount]: {
      agg: StatisticAggregateType.Count,
      type: StatisticModelType.CreditCard,
      query: {
        type: CreditCardType.Source,
        all: true,
      },
    },
    [StatisticsKeys.CreditCardsActiveSourceCount]: {
      agg: StatisticAggregateType.Count,
      type: StatisticModelType.CreditCard,
      query: {
        displayStatuses: [CreditCardDisplayStatus.Active],
        type: CreditCardType.Source,
      },
    },
  }
